/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { CompleteCourseOptions, CompleteCourseStatus200, CompleteCourseStatus422 } from '../models/CompleteCourse'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { completeCourse } from '../clients/axios/completeCourse'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const completeCourseMutationKey = () => [{ url: '/course/:course_id/complete' }] as const

export function completeCourseMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = completeCourseMutationKey()
  return mutationOptions<CompleteCourseStatus200, ResponseErrorConfig<CompleteCourseStatus422>, CompleteCourseOptions, TContext>({
    mutationKey,
    mutationFn: async({ path }) => {
      return await completeCourse({ ...config, path, throwOnError: true })
    },
  })
}

/**
 * @description Mark a course as completed by the authenticated user.
 * @summary Complete Course
 * {@link /course/:course_id/complete}
 */
export function useCompleteCourse<TContext>(options: {
  mutation?: UseMutationOptions<CompleteCourseStatus200, ResponseErrorConfig<CompleteCourseStatus422>, CompleteCourseOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? completeCourseMutationKey()

  const baseOptions = completeCourseMutationOptions(config) as UseMutationOptions<CompleteCourseStatus200, ResponseErrorConfig<CompleteCourseStatus422>, CompleteCourseOptions, TContext>

  return useMutation<CompleteCourseStatus200, ResponseErrorConfig<CompleteCourseStatus422>, CompleteCourseOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<CompleteCourseStatus200, ResponseErrorConfig<CompleteCourseStatus422>, CompleteCourseOptions, TContext>
}
